import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { RatesProvider } from "./code/Rates";
import { MyProvider } from "./code/My";
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RatesProvider>
      <AuthContextProvider>
        <MyProvider>
          <App />
        </MyProvider>
      </AuthContextProvider>
    </RatesProvider>
  </React.StrictMode>
);
reportWebVitals();
